export enum PUSH_AUDIENCE {
	ALL = 'ALL',
	ORGANIZATION = 'ORGANIZATION',
}

export type CustomPushFormValues = {
	title: string;
	body: string;
	audience: PUSH_AUDIENCE;
	organizationId: number | null;
};
